// REQUIRE PRELINE

require("preline/dist/preline.js");

// SET BREAKPOINTS

const break_sm = 640;
const break_md = 768;
const break_lg = 1024;
const break_xl = 1280;
const break_2xl = 1920;

// OPEN ALL EXTERNAL LINKS IN NEW WINDOW

document.addEventListener("DOMContentLoaded", () => {
	// Get the current domain
	const currentDomain = window.location.hostname;

	// Get all links on the page
	const links = document.querySelectorAll("a[href]");

	links.forEach((link) => {
		try {
			// Create a URL object to parse the link's href
			const url = new URL(link.href, window.location.origin);
			const linkDomain = url.hostname;

			// Check if the link's domain is different from the current domain
			if (linkDomain && linkDomain !== currentDomain) {
				// Add target="_blank" if not present
				if (!link.hasAttribute("target") || link.getAttribute("target") !== "_blank") {
					link.setAttribute("target", "_blank");
				}
				// Add rel="noopener noreferrer" for security if not present
				if (!link.hasAttribute("rel") || !link.getAttribute("rel").includes("noopener")) {
					link.setAttribute("rel", "noopener noreferrer");
				}
			}
		} catch (e) {
			// Handle invalid URLs (e.g., malformed href or relative URLs that can't be resolved)
			console.warn(`Invalid URL in link: ${link.href}`, e);
		}
	});
});

// BLURRED IMAGES

document.querySelectorAll(".blurred-img img").forEach((img) => {
	function loaded() {
		img.parentElement.classList.add("loaded");
	}

	if (img.complete) {
		loaded();
	} else {
		img.addEventListener("load", loaded);
	}
});

// THEMED HEADER

const header = document.querySelector(".header");
const sections = Array.from(document.querySelectorAll("[data-theme]"));

let lastTheme = null;

function updateHeaderTheme() {
	// Get the current position of the bottom of the header in viewport coordinates
	const headerBottom = header.getBoundingClientRect().bottom;

	for (const section of sections) {
		const rect = section.getBoundingClientRect();

		// Check if the header's bottom edge is inside this section
		if (rect.top <= headerBottom && rect.bottom >= headerBottom) {
			const newTheme = section.dataset.theme;

			if (newTheme !== lastTheme) {
				header.dataset.theme = newTheme;
				lastTheme = newTheme;
			}
			return; // Found it — no need to check further sections
		}
	}

	// Optional fallback (e.g., first section or default)
	if (lastTheme === null && sections.length > 0) {
		header.dataset.theme = sections[0].dataset.theme;
	}
}

// Performance-friendly scroll handler using requestAnimationFrame
let ticking = false;
window.addEventListener("scroll", () => {
	if (!ticking) {
		requestAnimationFrame(() => {
			updateHeaderTheme();
			ticking = false;
		});
		ticking = true;
	}
});

// Run on initial load and when window resizes (in case of dynamic content)
window.addEventListener("load", updateHeaderTheme);
window.addEventListener("resize", updateHeaderTheme);

// Fade In

document.addEventListener("DOMContentLoaded", () => {
	processTextAnimations();
	processFadeGroups(); // ← group base + stagger
	applyManualDelays(); // ← individual overrides (still works on lone elements too)
	setupFadeObserver();
});

function processTextAnimations() {
	document.querySelectorAll(".fade-in--letters, .fade-in--words").forEach((el) => {
		const isLetters = el.classList.contains("fade-in--letters");
		const originalText = el.textContent.trim();
		if (!originalText) return;

		// Preserve original direction classes
		const directionClasses = Array.from(el.classList).filter((cls) => cls.startsWith("fade-in--") && !["fade-in--letters", "fade-in--words"].includes(cls));

		el.innerHTML = "";
		el.classList.add("fade-text");
		el.classList.remove("fade-in", "fade-in--letters", "fade-in--words");

		if (isLetters) {
			// Split while preserving whitespace chunks
			const chunks = originalText.split(/(\s+)/);
			let delay = 0;
			const stagger = 22; // ms per letter

			chunks.forEach((chunk) => {
				if (/\s/.test(chunk)) {
					// Whitespace → add as real text node (preserves line breaks & spacing)
					el.appendChild(document.createTextNode(chunk));
				} else {
					// Word → wrap in a container so the word stays together
					const wordSpan = document.createElement("span");
					wordSpan.classList.add("fade-word");

					chunk.split("").forEach((char) => {
						const letterSpan = document.createElement("span");
						letterSpan.classList.add("fade-in");
						directionClasses.forEach((cls) => letterSpan.classList.add(cls));
						letterSpan.textContent = char;
						letterSpan.style.setProperty("--fade-delay", `${delay}ms`);
						wordSpan.appendChild(letterSpan);

						delay += stagger;
					});

					el.appendChild(wordSpan);
				}
			});
		} else {
			// Words only
			const words = originalText.split(/\s+/);
			let delay = 0;
			const stagger = 55;

			words.forEach((word, i) => {
				const span = document.createElement("span");
				span.classList.add("fade-in");
				directionClasses.forEach((cls) => span.classList.add(cls));
				span.textContent = word;
				span.style.setProperty("--fade-delay", `${delay}ms`);
				el.appendChild(span);

				delay += stagger;

				if (i < words.length - 1) {
					el.appendChild(document.createTextNode(" "));
				}
			});
		}
	});
}

function processFadeGroups() {
	document.querySelectorAll(".fade-group").forEach((group) => {
		const stagger = parseInt(group.dataset.stagger) || 70;

		// New: group-level starting delay (supports "500" or "500ms")
		let baseDelayMs = 0;
		if (group.dataset.delay) {
			baseDelayMs = parseInt(group.dataset.delay);
		}

		// Get only fade-in elements that belong to this group
		const fadeIns = Array.from(group.querySelectorAll(".fade-in")).filter((el) => el.closest(".fade-group") === group);

		fadeIns.forEach((child, i) => {
			// Start with group base + stagger
			let finalDelayMs = baseDelayMs + i * stagger;

			// Individual data-delay completely overrides the cascade
			if (child.dataset.delay) {
				finalDelayMs = parseInt(child.dataset.delay);
			}

			child.style.setProperty("--fade-delay", `${finalDelayMs}ms`);
		});
	});
}

function applyManualDelays() {
	document.querySelectorAll(".fade-in[data-delay]").forEach((el) => {
		const delayValue = el.dataset.delay;
		// Accept both "800" and "800ms"
		const delay = delayValue.endsWith("ms") ? delayValue : `${parseInt(delayValue)}ms`;

		el.style.setProperty("--fade-delay", delay);
	});
}

function setupFadeObserver() {
	const observer = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					if (entry.target.classList.contains("fade-group")) {
						triggerGroupCascade(entry.target);
					} else {
						// Lone elements (not in a group)
						entry.target.classList.add("fade-in--visible");
					}
					observer.unobserve(entry.target);
				}
			});
		},
		{
			threshold: 0.15,
			rootMargin: "0px 0px -40px 0px",
		},
	);

	// === Handle fade groups ===
	document.querySelectorAll(".fade-group").forEach((group) => {
		if (isInInitialViewport(group)) {
			triggerGroupCascade(group);
		} else {
			observer.observe(group);
		}
	});

	// === Handle lone .fade-in elements (not inside any group) ===
	document.querySelectorAll(".fade-in").forEach((el) => {
		// Skip if this element belongs to a group
		if (el.closest(".fade-group")) return;

		if (isInInitialViewport(el)) {
			el.classList.add("fade-in--visible");
		} else {
			observer.observe(el);
		}
	});
}

function triggerGroupCascade(group) {
	const fadeIns = Array.from(group.querySelectorAll(".fade-in")).filter((el) => el.closest(".fade-group") === group);

	fadeIns.forEach((child) => {
		child.classList.add("fade-in--visible");
	});
}

function isInInitialViewport(el) {
	const rect = el.getBoundingClientRect();
	return rect.top < window.innerHeight && rect.bottom > 0;
}

import { init } from "litelight-js";
import "litelight-js/css";

init();
